import React, { useEffect, useState, useCallback } from "react";
import api from "../../lib/api";
import { formatDate } from "../../lib/format";
import { toast } from "sonner";

export default function PreventiveTab() {
  const [suggested, setSuggested] = useState([]);
  const [plan, setPlan] = useState([]);
  const load = useCallback(() => {
    api.get("/preventive/suggested").then(r => setSuggested(r.data));
    api.get("/preventive").then(r => setPlan(r.data));
  }, []);
  useEffect(() => { load(); }, [load]);
  const approve = async () => {
    if (suggested.length === 0) return;
    try { await api.post("/preventive/plan", { items: suggested }); toast.success("Plan preventivo aprobado"); load(); }
    catch (e) { toast.error(e.response?.data?.detail || "Error"); }
  };
  return (
    <div className="max-w-4xl grid gap-4">
      <div className="q-card p-6">
        <h3 className="font-semibold mb-3">Sugerencias de QUILLA IA</h3>
        {suggested.length === 0 ? (
          <div className="text-sm text-[color:var(--q-muted)]">Sin sugerencias. Agrega activos y su categoría para que QUILLA IA proponga rutinas.</div>
        ) : (
          <>
            <div className="grid gap-2 mb-3">
              {suggested.map((s, i) => (
                <div key={i} className="text-sm flex items-center justify-between border-b border-[color:var(--q-border)] pb-2">
                  <div><span className="font-semibold">{s.asset_name}</span> · {s.task}</div>
                  <div className="text-xs text-[color:var(--q-muted)] font-mono">cada {s.days}d</div>
                </div>
              ))}
            </div>
            <button data-testid="preventive-approve" onClick={approve} className="q-btn-primary">Aprobar plan y activar</button>
          </>
        )}
      </div>
      <div className="q-card p-6">
        <h3 className="font-semibold mb-3">Plan activo ({plan.length})</h3>
        {plan.length === 0 ? (
          <div className="text-sm text-[color:var(--q-muted)]">Ningún preventivo activo aún.</div>
        ) : (
          <div className="grid gap-2">
            {plan.map(p => (
              <div key={p.id} className="text-sm flex items-center justify-between border-b border-[color:var(--q-border)] pb-2">
                <div><span className="font-semibold">{p.asset_name}</span> · {p.task}</div>
                <div className="text-xs text-[color:var(--q-muted)] font-mono">próx: {formatDate(p.next_due)}</div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
